import { UtilityService } from '../../../infrastructure/services/utils';
import { AnalyticsModel } from './AnalyticsModel';
import { AnalyticsActions } from './IAnalyticsTasks';
import { IRecentDelete } from './IRecentDelete';
import { AnalyticsConstants } from './constants';
import { appConstants } from '../../../application/configurations/constants';
/**
 * create model for analytics api recent search and clicked items
 * @param   {object} data api payload data
 * @param   {sting} idToken authentication token
 */
export class RecentDeleteModel extends AnalyticsModel {
  constructor(data: IRecentDelete) {
    const paxContextGuid = UtilityService.generateGuid();
    super(data, paxContextGuid);
    if (this.analyticsData.eventData) {
      const url =
        window.location.href.split('#').length > 0
          ? window.location.href.split('#')[1]
          : '';
      const currentPageURL =
        url === appConstants.routePaths.home
          ? appConstants.routePaths.home
          : appConstants.routePaths.results;

      this.analyticsData.recentDelete = [
        {
          ...this.analyticsData.eventData,
          Issues: [AnalyticsConstants.NoIssues],
          Action: AnalyticsActions.recentDelete,
          PageURL: (window.location.origin + '/#' + currentPageURL) ? window.location.origin + '/#' + currentPageURL : null,
        }
      ];
      delete this.analyticsData.eventData;
    }
  }
}
